import { render, staticRenderFns } from "./ImportTab.vue?vue&type=template&id=dd89d4ea"
import script from "./ImportTab.vue?vue&type=script&lang=js"
export * from "./ImportTab.vue?vue&type=script&lang=js"
import style0 from "./ImportTab.vue?vue&type=style&index=0&id=dd89d4ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports